module.exports = __webpack_public_path__ + "static/media/Steve.5946b958.png";